(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-category-tabs"] && !Shopify.designMode) return;
  try {
    
function initializeJMTabs(root) {
  root.querySelectorAll('[data-jm-tabs]').forEach(group => {
    if (group.dataset.initialized) return;
    group.dataset.initialized = 'true';
    const tabs = Array.from(group.querySelectorAll('[role="tab"]'));
    const panels = Array.from(group.querySelectorAll('[role="tabpanel"]'));
    function activate(tab) {
      tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
      });
    });
  });
}
initializeJMTabs(document);
document.addEventListener('shopify:section:load', event => initializeJMTabs(event.target));
document.addEventListener('shopify:block:select', event => { const group = event.target.closest('[data-jm-tabs]'); if (!group) return; const tab = Array.from(group.querySelectorAll('[data-jm-tab-block]')).find(item => item.dataset.jmTabBlock === event.detail.blockId); tab?.click(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-coupon"] && !Shopify.designMode) return;
  try {
    
function initializeJMCoupon(root) {
  root.querySelectorAll('[data-jm-coupon]').forEach(banner => {
    if (banner.dataset.initialized) return;
    banner.dataset.initialized = 'true';
    const button = banner.querySelector('[data-copy-coupon]');
    const status = banner.querySelector('[data-coupon-status]');
    button.addEventListener('click', async () => {
      let copied = false;
      try {
        await navigator.clipboard.writeText(button.dataset.copyCoupon);
        copied = true;
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = button.dataset.copyCoupon;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
        button.focus();
      }
      button.textContent = copied ? banner.dataset.copied : button.dataset.copyCoupon;
      status.textContent = button.textContent;
      clearTimeout(button.jmResetTimer);
      button.jmResetTimer = setTimeout(() => { button.textContent = banner.dataset.button; }, 4000);
    });
  });
}
initializeJMCoupon(document);
document.addEventListener('shopify:section:load', event => initializeJMCoupon(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-home"]) return;
  try {
    
function initializeJMTabs(root) {
  root.querySelectorAll('[data-jm-tabs]').forEach(group => {
    if (group.dataset.initialized) return;
    group.dataset.initialized = 'true';
    const tabs = Array.from(group.querySelectorAll('[role="tab"]'));
    const panels = Array.from(group.querySelectorAll('[role="tabpanel"]'));
    function activate(tab) {
      tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
      });
    });
  });
}
initializeJMTabs(document);
document.addEventListener('shopify:section:load', event => initializeJMTabs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-personalizado"]) return;
  try {
    
function initializeJMCustom(root) {
  root.querySelectorAll('[data-personalizado]').forEach(page => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const track = page.querySelector('[data-gallery-track]');
    const photos = Array.from(page.querySelectorAll('[data-gallery-photo]'));
    const previous = page.querySelector('[data-gallery-prev]');
    const next = page.querySelector('[data-gallery-next]');
    const status = page.querySelector('[data-gallery-status]');
    const dialog = page.querySelector('[data-gallery-dialog]');
    let active = 0;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    function update() {
      previous.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      const width = photos[0]?.closest('li').getBoundingClientRect().width || 1;
      const current = Math.min(photos.length, Math.round(track.scrollLeft / (width + (window.innerWidth < 750 ? 14 : 24))) + 1);
      status.textContent = current + ' / ' + photos.length;
    }
    previous.addEventListener('click', () => track.scrollBy({left: -track.clientWidth, behavior}));
    next.addEventListener('click', () => track.scrollBy({left: track.clientWidth, behavior}));
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
    function showPhoto(index) {
      active = (index + photos.length) % photos.length;
      const source = photos[active].querySelector('img');
      const target = dialog.querySelector('[data-lightbox-image]');
      target.src = source.currentSrc || source.src;
      target.alt = source.alt;
      dialog.querySelector('[data-lightbox-caption]').textContent = source.alt + ' · ' + (active + 1) + ' / ' + photos.length;
    }
    photos.forEach((photo,index) => photo.addEventListener('click', () => {showPhoto(index); dialog.showModal();}));
    dialog.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-lightbox-prev]').addEventListener('click',()=>showPhoto(active-1));
    dialog.querySelector('[data-lightbox-next]').addEventListener('click',()=>showPhoto(active+1));
    dialog.addEventListener('keydown',event=>{
      if(event.key==='ArrowRight'){event.preventDefault();showPhoto(active+1);}
      if(event.key==='ArrowLeft'){event.preventDefault();showPhoto(active-1);}
    });
  });
}
initializeJMCustom(document);
document.addEventListener('shopify:section:load',event=>initializeJMCustom(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jm-project-gallery"] && !Shopify.designMode) return;
  try {
    

function initializeJMCustom(root) {
  root.querySelectorAll('[data-personalizado]').forEach(page => {
    if (page.dataset.initialized) return;
    page.dataset.initialized = 'true';
    const track = page.querySelector('[data-gallery-track]');
    const photos = Array.from(page.querySelectorAll('[data-gallery-photo]'));
    const previous = page.querySelector('[data-gallery-prev]');
    const next = page.querySelector('[data-gallery-next]');
    const status = page.querySelector('[data-gallery-status]');
    const dialog = page.querySelector('[data-gallery-dialog]');
    let active = 0;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    function update() {
      previous.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      const width = photos[0]?.closest('li').getBoundingClientRect().width || 1;
      const current = Math.min(photos.length, Math.round(track.scrollLeft / (width + (window.innerWidth < 750 ? 14 : 24))) + 1);
      status.textContent = current + ' / ' + photos.length;
    }
    previous.addEventListener('click', () => track.scrollBy({left: -track.clientWidth, behavior}));
    next.addEventListener('click', () => track.scrollBy({left: track.clientWidth, behavior}));
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
    function showPhoto(index) {
      active = (index + photos.length) % photos.length;
      const source = photos[active].querySelector('img');
      const target = dialog.querySelector('[data-lightbox-image]');
      target.src = source.currentSrc || source.src;
      target.alt = source.alt;
      dialog.querySelector('[data-lightbox-caption]').textContent = source.alt + ' · ' + (active + 1) + ' / ' + photos.length;
    }
    photos.forEach((photo,index) => photo.addEventListener('click', () => {showPhoto(index); dialog.showModal();}));
    dialog.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-lightbox-prev]').addEventListener('click',()=>showPhoto(active-1));
    dialog.querySelector('[data-lightbox-next]').addEventListener('click',()=>showPhoto(active+1));
    dialog.addEventListener('keydown',event=>{
      if(event.key==='ArrowRight'){event.preventDefault();showPhoto(active+1);}
      if(event.key==='ArrowLeft'){event.preventDefault();showPhoto(active-1);}
    });
  });
}
initializeJMCustom(document);
document.addEventListener('shopify:section:load',event=>initializeJMCustom(event.target));


  } catch(e) { console.error(e); }
})();
})();
